import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledUsersSort = styled('div')(
  () => css`
    display: flex;
    align-items: center;
    gap: 8px;

    .sort-field {
      min-width: 200px;
      max-width: 240px;
    }

    .sort-order-btn {
      min-width: 36px;
      width: 36px;
      height: 36px;
      padding: 0;
    }
  `
);
